import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "component"
}

import { computed, onMounted, PropType } from 'vue';
import { useStore } from 'vuex';
import { HardwareComponent, TypeLabel } from '@/models/hardware.model';
import Property from '@/components/system/components/Property.vue';
import { Actions } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'GenericComponent',
  props: {
  component: {
    type: Object as PropType<HardwareComponent | null>,
    required: true,
  },
  full: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const { component, full } = __props;


const store = useStore();

onMounted(() => {
  store.dispatch(Actions.GetHardwareConfiguration);
});

const propertyTypes = computed<TypeLabel[]>(
  () => store.state.hardwareConfiguration?.propertyTypes || [],
);

const getPropertyLabel = (v: string) => {
  return propertyTypes.value.find((i) => i.value === v)?.label || `(${v})`;
};

return (_ctx: any,_cache: any) => {
  return (__props.component)
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
        _createElementVNode("div", null, _toDisplayString(__props.component.fullName), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.component.properties, (p) => {
          return (_openBlock(), _createBlock(Property, {
            key: p.type,
            component: __props.component,
            property: p.type,
            label: __props.full ? getPropertyLabel(p.type) : ''
          }, null, 8, ["component", "property", "label"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})